import { render, staticRenderFns } from "./layered-background.vue?vue&type=template&id=d6cfddb4&scoped=true"
import script from "./layered-background.vue?vue&type=script&lang=js"
export * from "./layered-background.vue?vue&type=script&lang=js"
import style0 from "./layered-background.vue?vue&type=style&index=0&id=d6cfddb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cfddb4",
  null
  
)

export default component.exports